import React, {useRef} from "react";
import styles from "../name-input/name-input.module.css";

const NameInput = ({defaultVal, setValue, setValid, inputNameStyles}) => {
    const input = useRef(null);

    const checkValidity = () => {
        const valid = input.current.checkValidity();
        setValid(valid)
        if (valid) {
            setValue(input.current.value)
        }
    }

    return (
        <input
            ref={input}
            type="text"
            required
            className={styles.input_name}
            defaultValue={defaultVal}
            onChange={() => checkValidity()}
            style={inputNameStyles}
        />
    );
};

export {NameInput};